export default __webpack_public_path__ + "static/media/logoimg.cae81afa.png";